import { mapGetters } from 'vuex';
import ProductsCategoryFilter from '@/components/products/ProductsCategoryFilter/index.vue';

export default {
  name: 'ProductsSidebarFilters',
  components: {
    ProductsCategoryFilter
  },
  props: {},
  emits: [],
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters({
      filters: 'selection/filters'
    })
  },
  methods: {},
  unmounted() {}
};
